import React, {useEffect, useRef, useState} from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import MultiSelect from "./multi-select";
import CreatableSelect from "react-select/creatable";
import AsyncMultiSelect from "./async-multi-select";

const SelectComponent = (props) => {
    const selectRef = useRef(null);
    const {isDisabled} = props;
    const [activeLabel, setActiveLabel] = useState(!props.isMulti ? props.value !== undefined && props.value !== '' && props.value !== null : !!props.value.length);

    useEffect(() => {
        setActiveLabel(!props.isMulti ? props.value !== undefined && props.value !== '' && props.value !== null : !!props.value.length);
    }, [props.isMulti, props.value]);

    const onMenuOpen = () => {
        setActiveLabel(true);
    }

    const onMenuClose = () => {
        if (!props.value || (props.isMulti && !props.value.length)) {
            setActiveLabel(false)
        }

        if (props.eventMenuClose) props.eventMenuClose();
    }

    const customStyles = {
        control: (base) => {
            return {
                ...base,
                height: "32px",
                minHeight: "32px",
                borderColor: "#d1d5db"
            };
        },
        menu: (def) => ({...def, zIndex: 2000}),
        menuPortal: (base) => ({...base, zIndex: 3000}),
        singleValue: (def) => ({...def, top: "-2px", position: "relative"}),
        indicatorsContainer: (def) => ({...def, top: "-3px", position: "relative"}),
    }

    const handleLabelClick = () => {
        if (selectRef.current) {
            selectRef.current.focus();
            setActiveLabel(true);
        }
    }
    return (
        <div className={"relative min-w-0 max-w-full " + props.col}>
            {
                props.isAsync && !props.isMulti &&
                <AsyncSelect
                    ref={selectRef}
                    {...props}
                    value={(typeof props.value === "string" && props.value) ? props.options.find(opt => opt.value.includes(props.value)) : props.value}
                    placeholder={""}
                    styles={customStyles}
                    onMenuOpen={onMenuOpen}
                    onMenuClose={onMenuClose}
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Nenhum item encontrado"}
                    isClearable={true}
                    openMenuOnFocus={true}
                />
            }

            {
                !props.isAsync && !props.isMulti && !props.isCreatable &&
                <Select
                    {...props}
                    ref={selectRef}
                    value={(typeof props.value === "string" && props.value) ? props.options?.find(opt => opt.value?.includes(props.value)) ?? "" : props.value}
                    placeholder={""}
                    styles={customStyles}
                    onMenuOpen={onMenuOpen}
                    onMenuClose={onMenuClose}
                    openMenuOnFocus={true}
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Nenhum item encontrado"}
                    isClearable={props?.isClearable ?? true}
                />
            }

            {
                props.isAsync && props.isMulti &&
                <AsyncMultiSelect
                    {...props}
                    placeholder={""}
                    openMenuOnFocus={true}
                    onMenuOpen={onMenuOpen}
                    onMenuClose={onMenuClose}
                    loadingMessage={() => "Carregando..."}
                    place={() => "Carregando..."}
                    noOptionsMessage={() => "Nenhum item encontrado"}
                    selectRef={selectRef}
                />
            }

            {
                !props.isAsync && props.isMulti &&
                <MultiSelect
                    {...props}
                    placeholder={""}
                    openMenuOnFocus={true}
                    onMenuOpen={onMenuOpen}
                    onMenuClose={onMenuClose}
                    loadingMessage={() => "Carregando..."}
                    place={() => "Carregando..."}
                    noOptionsMessage={() => "Nenhum item encontrado"}
                    selectRef={selectRef}
                />
            }

            {
                props.isCreatable && !props.isMulti &&
                <CreatableSelect
                    {...props}
                    ref={selectRef}
                    value={(typeof props.value === "string" && props.value)
                        ? props.options?.find(opt => opt.value === props.value) ?? {
                            value: props.value,
                            label: props.value,
                        }
                        : props.value}
                    placeholder={""}
                    styles={customStyles}
                    onMenuOpen={onMenuOpen}
                    onMenuClose={onMenuClose}
                    openMenuOnFocus={true}
                    loadingMessage={() => "Carregando..."}
                    noOptionsMessage={() => "Nenhum item encontrado"}
                    isClearable={props?.isClearable ?? true}
                    createOptionPosition="first"
                />
            }

            <label htmlFor={props.instanceId}
                   onClick={handleLabelClick}
                   className={`absolute text-sm text-gray-500 duration-300 transform 
                   ${activeLabel ? "-translate-y-4 scale-75" : "scale-100"} top-[5px] z-10 origin-[0] bg-white px-1 left-2.5
                   ${isDisabled ? ((props.value || props.defaultValue) ? "bg-label-disabled" : "") : "bg-white"}`}>
                {props.label}
            </label>
        </div>
    );
}

export default SelectComponent;
